import React, { useEffect, useRef, useState } from "react";
import LaboratoriesViewModel from "../../../viewmodels/setup/laboratories/LaboratoriesViewModel";
import SimpleNotification from "../../../components/SimpleNotification";
import { connect } from "react-redux";
import * as actions from "../../../store/actions/index";
import SlideOver from "../../../components/slideOver/SlideOver";
import EmptyModal from "../../../components/modals/EmptyModal";
import AuditActionLink from "../../../components/audit/AuditActionLink";
import AuditHistoriesLink from "../../../components/audit/AuditHistoriesLink";
import { Paginator } from "primereact/paginator";
import { withRouter } from "../../../shared/utility";
import OperationalDataTableSkeleton from "../../../components/operational/OperationalDataTableSkeleton";

function Laboratories(props) {
  const { logout } = props;
  const [initialLoading, setInitialLoading] = useState(true);

  const {
    getLaboratories,
    loading,
    laboratories,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    setShowSimpleNotification,
    showSimpleNotification,
    openAddLaboratorySlideOver,
    askDeleteLaboratory,
  } = LaboratoriesViewModel(logout);

  const currentPageRef = useRef(1);
  useEffect(() => {
    currentPageRef.current = 1;
    getLaboratories(null, 1).finally(() => setInitialLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchRef = useRef();

  const handleSearch = () => {
    getLaboratories(searchRef.current.value, 1);
  };

  const [first, setFirst] = useState(1);
  const [rows, setRows] = useState(20);

  const handlePagination = (event) => {
    const page = event.page + 1;
    currentPageRef.current = page;
    setFirst(event.first);
    setRows(event.rows);
    getLaboratories(searchRef.current.value, page);
  };

  return (
    <div>
      <SimpleNotification
        setShow={setShowSimpleNotification}
        showSimpleNotification={showSimpleNotification}
      />
      <div className="mt-2 px-4 sm:px-8">
        <div className="sm:flex sm:items-center px-4 py-5 sm:px-4 card-custom">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Laboratories
            </h1>
            <div className="mt-5 flex rounded-md">
              <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <input
                  type="search"
                  className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                  placeholder="Search by name"
                  ref={searchRef}
                  onKeyDown={(e) => (e.key === "Enter" ? handleSearch() : null)}
                />
              </div>
              <button
                type="button"
                className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                onClick={() => handleSearch()}
              >
                Search
              </button>

              <div className="ml-4">
                <button
                  className="rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 disabled:cursor-wait disabled:opacity-50"
                  onClick={() => openAddLaboratorySlideOver(false, null, null)}
                  disabled={loading || initialLoading}
                >
                  Add
                </button>
              </div>
              <AuditHistoriesLink slug="laboratory" className="ml-3" />
            </div>
          </div>
        </div>

        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              {loading ? (
                <OperationalDataTableSkeleton
                  columns={[
                    "#",
                    "Name",
                    "City",
                    "Address 1",
                    "Address 2",
                    "Notes",
                    "Actions",
                  ]}
                  rows={8}
                />
              ) : (
                <div className="overflow-hidden card-custom">
                  <table className="min-w-full divide-y divide-gray-300">
                    <thead className="bg-white">
                      <tr>
                        <th className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">
                          #
                        </th>
                        <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                          Name
                        </th>
                        <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                          City
                        </th>
                        <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                          Address 1
                        </th>
                        <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                          Address 2
                        </th>
                        <th className="px-3 py-3 text-left text-sm font-semibold text-gray-900">
                          Notes
                        </th>
                        <th className="relative py-3 pl-3 pr-4 sm:pr-6"></th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200 bg-white">
                      {laboratories.data && laboratories.data.length > 0 ? (
                        laboratories.data.map((lab) => (
                          <tr key={lab.id}>
                            <td className="whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                              {lab.id}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                              {lab.name}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                              {lab.city}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                              {lab.address1}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                              {lab.address2}
                            </td>
                            <td className="whitespace-nowrap px-3 py-2 text-sm text-gray-500">
                              {lab.notes}
                            </td>
                            <td className="relative whitespace-nowrap py-2 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              <button
                                className="ml-5 rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600"
                                onClick={() =>
                                  openAddLaboratorySlideOver(true, lab, 0)
                                }
                              >
                                Edit
                              </button>
                              <AuditActionLink
                                slug="laboratory"
                                id={lab.id}
                                name={lab.name}
                                className="ml-2"
                              />
                              <button
                                className="ml-2 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500"
                                onClick={() => askDeleteLaboratory(lab, 0)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className="text-center py-4">
                            No laboratories found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="w-full mt-2">
              <Paginator
                first={first}
                rows={rows}
                totalRecords={laboratories.total}
                onPageChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </div>

      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
      />

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Laboratories),
);
